import { ActionTypes } from 'utils/constants';
import axios from 'axios';
import { getEnvVar } from 'utils/get-env-var';
import { tripleWhaleProductView } from 'utils/triple-whale';
import { klaviyoViewedProduct } from 'utils/klaviyo';

export const fetchCourseForModal = slug => (
    {
        type: ActionTypes.FETCH_MODAL_COURSE,
        payload: axios.get(`${getEnvVar('API_BASE')}/course/${slug}`)
    }
);

export const openCourseModal = (slug, name) => {
    document.body.style.overflow = 'hidden';

    // Previewing a course is this site's product view. Every entry point into the
    // course modal (thumbs, list items, the curriculum, "Preview Course", recent
    // courses) goes through here, so this is the one place it needs to fire.
    //
    // The slug is the product id rather than the numeric course id: it is what the
    // routes and the API use, so it stays readable in Triple Whale's reporting.
    //
    // No price: courses are not sold individually, only bundled into the
    // membership, so any figure here would be invented. Triple Whale lists price
    // among the product context fields, so confirm with them whether ViewContent
    // needs one before putting the membership price on every course.
    tripleWhaleProductView({ id: slug, name });

    // Klaviyo's equivalent, fired from the same place for the same reason. It
    // takes the course's own URL rather than the current one, since the modal
    // opens over whichever page the visitor was already on.
    klaviyoViewedProduct({
        id: slug,
        name,
        url: `${getEnvVar('SITE_URL')}${getEnvVar('ROOT_ROUTE')}/course/${slug}`
    });

    return {
        type: ActionTypes.OPEN_COURSE_MODAL,
        payload: { slug, name }
    }
};

export const closeCourseModal = () => {
    document.body.style.overflow = 'visible';

    return {
        type: ActionTypes.CLOSE_COURSE_MODAL
    }
};

export const playCoursePreview = () => (
    {
        type: ActionTypes.PLAY_COURSE_PREVIEW
    }
);

export const stopCoursePreview = () => (
    {
        type: ActionTypes.STOP_COURSE_PREVIEW
    }
);